module.exports = __webpack_public_path__ + "static/media/xiaoaiOpen.a8d10481.png";